/* 🤖 this file was generated by script */
export const wiconChartBreakoutCircle = {
  name: 'chart_breakout_circle',
  data: `<svg viewBox="0 0 24 24"><path fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15.5 3.5V2m3.94 2.56L20.5 3.5m.01 5h1.5m-.06 4.5A10 10 0 1111 2.05M12 8h4v4m-.38-4a12.98 12.98 0 01-13.54 5.17"/></svg>`,
};
